import { createAction, createReducer } from '@reduxjs/toolkit';

import {
    ACKNOWLEDGE_NOTIFICATION_ERROR,
    ACKNOWLEDGE_NOTIFICATION_SUCCESS,
    FETCH_NOTIFICATIONS_SUCCESS,
} from '@perpay-web/fintech/constants/actionTypes';

export enum NotificationType {
    PERPAY_PLUS_TYPE = 'perpay_plus',
    CARD_REWARDS = 'perpay_credit_card_direct_deposit_rewards',
    CARD_CREDIT_LIMIT_INCREASE = 'perpay_credit_card_credit_limit_increase',
    PHO_EXISTING_USER = 'partner_hosted_card_onboarding_existing_user',
    MP_PHO_EXISTING_USER = 'mp_partner_hosted_card_onboarding_existing_user',
    VIRTUAL_PROVISIONING = 'virtual_provisioning',
    OVERPAYMENT = 'overpayment',
}

export type Notification = {
    uuid: string;
    amount: number;
    acknowledged?: Date;
    type: NotificationType;
    payload: {
        cardShipment?: boolean;
        orderShipment?: boolean;
        overpaymentAmount?: number;
        withdrawalRequestUuid?: string;
    };
};

const fetchNotificationSuccessAction = createAction<Notification[]>(
    FETCH_NOTIFICATIONS_SUCCESS,
);
const acknowledgeNotificationSuccessAction = createAction(
    ACKNOWLEDGE_NOTIFICATION_SUCCESS,
);
const acknowledgeNotificationErrorAction = createAction(
    ACKNOWLEDGE_NOTIFICATION_ERROR,
);

const initialState: { [uuid: string]: Notification } = {};

const notificationsReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(fetchNotificationSuccessAction, (state, action) => ({
            ...state,
            ...Object.fromEntries(action.payload.map((n) => [n.uuid, n])),
        }))
        .addCase(acknowledgeNotificationSuccessAction, (state) => state)
        .addCase(acknowledgeNotificationErrorAction, (state) => state);
});

export default notificationsReducer;
